import { request } from '@/shared/api/request'

export const excludeTradeUnion = (params, parentBin) => {
	return request({ url: `colcontract/tradeUnion/excludeTradeUnion/${params}`, method: 'POST', params: {parentBin}, data: { parentBin } })
}